<script>
export default {
  props: {
    routes: {
      type: Array,
      default: () => [],
      validator: v => {
        return Array.isArray(v) && v.every(route => {
          return typeof route.label === 'string'
        })
      }
    }
  },
  methods: {
    navigate (route) {
      // aceita undefined
      if (route.name && this.$route.name !== route.name && route.disabled !== false) {
        this.$router.push({ name: route.name })
      }
    }
  }
}
</script>

<template>
  <div class="router-nav">
    <span @click="$emit('goHome')" class="color-primary"><i class="fas fa-home home-icon"></i></span>
    <i class="fa fa-chevron-right chevron-icon"></i>
    <span v-for="(route, index) in routes" :key="route.name || index" class="router-name">
      <span
        :class="[(index === routes.length - 1 ? 'color-primary' : 'font-weight-500'), {'cursor-pointer': route.name && index < routes.length - 1}]"
        @click="navigate(route)"
      >
        {{ route.label }}
      </span>
      <i v-if="index < routes.length - 1" class="fa fa-chevron-right chevron-icon ml-5px"></i>
    </span>
  </div>
</template>

<style lang="scss" scoped>
  @import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/components(new)/layout/LayoutBases/LayoutAnalise/Nav/Nav.vue